import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import styled from 'styled-components'
import 'antd/dist/antd.css'

import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import reportWebVitals from './reportWebVitals'
import configureStore from './Stores/configureStore'
import { history } from './Stores/reducers'
import ThemeProvider, { ThemedGlobalStyle } from './Themes'

const VerticalBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: space-between;
`

const initialState = {}
const store = configureStore(initialState, history)

const container = document.getElementById('root')
const root = createRoot(container)

const app = (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <VerticalBox>
        <ThemeProvider>
          <ThemedGlobalStyle />
          <App />
        </ThemeProvider>
      </VerticalBox>
    </ConnectedRouter>
  </Provider>
)

root.render(
  process.env.NODE_ENV !== 'production' ? <React.StrictMode>{app}</React.StrictMode> : app
)
// If you want your app to work offline and load faster, you can change
// unregister() to register-individual() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
